import { Collapse, IconButton } from '@material-ui/core';
import cx from 'classnames';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { RichTextWithEmbeds } from 'components/RichText';

import ExpandIcon from '../../images/caret.svg';
import { Typography } from '../Typography';
import { useStyles } from './styles';

export interface JobDescriptionProps {
  title: string | JSX.Element;
  body: string;
}

export const JobDescription: React.VFC<JobDescriptionProps> = ({
  title,
  body,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const styles = useStyles();
  const intl = useIntl();

  const toggleCaret = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div>
      <div className={styles.headerContainer}>
        <IconButton
          aria-label={intl.formatMessage({
            defaultMessage: 'Expand Job Description Icon',
            description: 'Shows job description',
          })}
          className={styles.caretButton}
          onClick={toggleCaret}
        >
          <img
            alt="ExpandIcon"
            className={cx({ [styles.caretIconCollapsed]: !collapsed })}
            src={ExpandIcon}
          />
        </IconButton>
        <Typography variant="headingMD">{title}</Typography>
      </div>
      <Collapse in={collapsed}>
        <RichTextWithEmbeds text={body} />
      </Collapse>
    </div>
  );
};
